import './navbar.scss'
import { React, useState, useEffect} from 'react'
import { useNavigate  } from "react-router-dom";
import { auth } from "../../services/firebase";
import { signOut } from "firebase/auth";

import { AboutGallery } from '../../galleryImg.js'

import SectionContextMenu from '../sectionContextMenu/SectionContextMenu.jsx'

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SocialHub from '../socialHub/SocialHub';

// Legacy RULES variable removed

const Navbar = ({ variant }) => {
    const url = window.location.pathname;
    const navigate = useNavigate()

    const userName = localStorage.getItem('user') || 'Log In';
    let [tools, setTools] = useState({});
    const [contextMenu, setContextMenu] = useState(false);

    useEffect(() => {
        try {
            const allowed = JSON.parse(localStorage.getItem('allowed_projects') || "[]");
            if (allowed.includes("/dashboard")) {
                setTools({ "Dashboard": "/dashboard" });
            } else {
                setTools({});
            }
        } catch (e) {
            setTools({});
        }
    }, [url]);

    const handleLogout = async (e) => {
        setContextMenu(false)
        localStorage.removeItem('password')
        localStorage.removeItem('user')
        localStorage.removeItem('allowed_projects')
        
        try {
            await signOut(auth);
        } catch (error) {
            console.error("Error signing out of Firebase", error);
        }
        
        window.location.reload(true);
    }

    const clickProfileButton = ((e) => {
        if (userName === "Log In") {
            window.dispatchEvent(new CustomEvent('trigger-login'));
        } else {
            setContextMenu(contextMenu ? false : true)
        }
    })


    const [menu, setMenu] = useState(false);
    const [activeMenu, setActiveMenu] = useState(null);

    return (
        <div className={`navbar ${variant ? `variant-${variant}` : ""}`}>
            <div className="top">

                <div className="logo">
                    <a href="/home">
                        <img className="mainLogo" src={AboutGallery[1].imgHigh} alt="" />
                    </a>
                </div>

                <div className="sections">
                    <div className="section">
                        <SectionContextMenu section={"home"} activeMenu={activeMenu} setActiveMenu={setActiveMenu}/>
                    </div>

                    <div className="section">
                        <SectionContextMenu section={"work"} activeMenu={activeMenu} setActiveMenu={setActiveMenu}/>
                    </div>
                    
                    <div className="section">
                        <SectionContextMenu section={"personal"} activeMenu={activeMenu} setActiveMenu={setActiveMenu}/>
                    </div>

                        <div className="section">
                            <SectionContextMenu section={"about"} activeMenu={activeMenu} setActiveMenu={setActiveMenu}/>
                        </div>

                </div>

                <div className="right">
                    <div className={ userName ? "login true" : "login" }>

                        <div className="loginButton" onClick = {() => clickProfileButton()}>
                            <AccountCircleOutlinedIcon className='icon'/>
                            <h1>{userName || "Log In"}</h1>
                        </div>

                        <div className={contextMenu ? "contextMenu true" : "contextMenu" }>
                            {Object.entries(tools).map( ([section, link]) =>{
                                return(
                                    <h1 key={section} className='option' onClick = {() => navigate(link)}>{section}</h1>
                                )
                            })}
                            
                            <h1 className='option' onClick = {() => handleLogout()}>Logout</h1>
                        </div>

                    </div>
                    
                    <SocialHub className="navbarSocial" alignment="right" />

                    <div className="menuToggle">
                        <div className={menu? "menuToggle open" : "menuToggle"}>
                            <MenuRoundedIcon className="icon" onClick = {() => setMenu(true)}/>
                        </div>
                        <div className={menu? "menuClose open" : "menuClose"}>
                            <CloseRoundedIcon className="icon" onClick = {() => setMenu(false)}/>
                        </div>
                    </div>
                </div>



            </div>

            <div className="optionMenu">

                <div className={menu? "menu open" : "menu"}>
                    <div className="sections">
                        <div className="section">
                            <SectionContextMenu section={"home"} activeMenu={activeMenu} setActiveMenu={setActiveMenu}/>
                        </div>

                        <div className="section">
                            <SectionContextMenu section={"work"} activeMenu={activeMenu} setActiveMenu={setActiveMenu}/>
                        </div>
                        <div className="section">
                            <SectionContextMenu section={"personal"} activeMenu={activeMenu} setActiveMenu={setActiveMenu}/>
                        </div>

                        <div className="section">
                            <SectionContextMenu section={"about"} activeMenu={activeMenu} setActiveMenu={setActiveMenu}/>
                        </div>
                    </div> 

                    <SocialHub className="navbarSocial" alignment="center" />

                </div>
            </div>

        </div>
    );
};


export default Navbar